import { render, staticRenderFns } from "./SliderPage.vue?vue&type=template&id=2f7173dc&"
import script from "./SliderPage.vue?vue&type=script&lang=js&"
export * from "./SliderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports